export const quickbooksContactConstants = {
  QUICKBOOKS_CONTACT_LIST_LOADING: 'QUICKBOOKS_CONTACT_LIST_LOADING',
  QUICKBOOKS_CONTACT_LIST_SUCCESS: 'QUICKBOOKS_CONTACT_LIST_SUCCESS',
  QUICKBOOKS_CONTACT_LIST_FAILURE: 'QUICKBOOKS_CONTACT_LIST_FAILURE',

  QUICKBOOKS_CONTACT_EDIT_LOADING: 'QUICKBOOKS_CONTACT_EDIT_LOADING',
  QUICKBOOKS_CONTACT_EDIT_SUCCESS: 'QUICKBOOKS_CONTACT_EDIT_SUCCESS',
  QUICKBOOKS_CONTACT_EDIT_FAILURE: 'QUICKBOOKS_CONTACT_EDIT_FAILURE'
};
